import React from 'react';

export default function HomeCounter() {
  return (
    <>
      <section className="counter-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-12 col-md-5">
              <div className="text-section" data-aos="slide-right">
                <h2 className="heading"> Real Value, <br /> Real Fast. </h2>
                <div className="text">
                  <p>
                    Optimized warehousing, seamless logistics, and swift
                    deliveries. We ensure efficiency at every step, reducing costs
                    and maximizing productivity. Your supply chain, faster and
                    smarter than ever!
                  </p>
                </div>
              </div>
            </div>

            {/* Right counter boxes */}
            <div className="col-sm-12 col-md-7 col-lg-7">
              <div className="grid-section">
                <div className="row">

                  <div className="col-6 col-sm-6 col-md-6">
                    <div className="box black">
                      <h2 className="heading">
                        <span className="stat-number">
                          12
                        </span>
                        %
                      </h2>
                      <p>Savings in freight cost</p>
                    </div>
                  </div>

                  <div className="col-6 col-sm-6 col-md-6">
                    <div className="box red">
                      <h2 className="heading">
                        <span className="stat-number">
                          18
                        </span>%
                      </h2>
                      <p>Improvement in service levels</p>
                    </div>
                  </div>

                  <div className="col-6 col-sm-6 col-md-6">
                    <div className="box red">
                      <h2 className="heading">
                        <span className="stat-number">
                          90
                        </span>%
                      </h2>
                      <p>Reduction in manual efforts</p>
                    </div>
                  </div>

                  <div className="col-6 col-sm-6 col-md-6">
                    <div className="box black">
                      <h2 className="heading">
                        <span className="stat-number">
                          24
                        </span>%
                      </h2>
                      <p>Reduction in carbon emissions</p>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

    </>
  )
}
